import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { GroupBaselineDeviation } from '../../../interfaces/ng-oct-report.interface';

@Component({
    selector: 'lib-group-security-control',
    templateUrl: './group-security-control.component.html',
    styleUrls: ['./group-security-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupSecurityControlComponent implements OnInit {
    @Input() groupBaselineDeviations: GroupBaselineDeviation | null = null;

    constructor() {}

    ngOnInit() {}

    public hasDeviation(value: any) {
        return Object.values(value).length > 0;
    }
}
